export enum ContentDisplayModes {
  NONE = 'NONE',
  PORT_INITIAL = 'PORT_INITIAL',
  CONTAINER_NO = 'CONTAINER_NO'
}
